<template>
<!-- 资金管理 -->
<section class="viewContainer">
  <!-- 资金账户&客源大厅&用户钱包&管理端&运营充值记录 -->
  <div v-if="switchTab">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClickfive">
      <el-tab-pane label="资金账户" name="zjzh"/>
      <el-tab-pane label="客源大厅" name="first"/>
      <!-- <el-tab-pane label="用户钱包" name="second"/>
      <el-tab-pane label="管理端" name="third"/>
      <el-tab-pane label="运营充值记录" name="fourth"/> -->
    </el-tabs>
    <!-- 资金账户 -->
    <div v-show="activeName=='zjzh'">
      <!-- 搜索/查询 -->
      <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <div class="goodslist1">
            <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
            <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
          </div>
          <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
        </div>
        <el-collapse-transition>
        <div v-show="show3">
          <!-- 顶部搜索框 -->
          <el-form class="findform">
            <el-form-item style="display:flex;width:30%" label="账号ID：">
              <el-input v-model="zhanghaoid" placeholder="请输入账号ID" maxlength="20" style="width:90%;"/>
            </el-form-item>
            <el-form-item style="display:flex;width:30%" label="账户名称：">
              <el-input v-model="zhanghaoname" placeholder="请输入账号名称" maxlength="20" style="width:90%;"/>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        </el-collapse-transition>
      </div>
      <!--资金账户列表-->
      <div class="main_container">
        <section class="model_section">
          <el-col :span="18"> <p class="model_top_title">资金账户</p> </el-col>
        </section>
        <div class="table_container">
          <el-table :data="zjzhlist" stripe border>
            <el-table-column label="序号" align="center" width="60">
              <template scope="scope">{{scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column label="账户ID" prop="vmid" align="center"/>
            <el-table-column label="账户类型" prop="businesstypename" align="center"/>
            <el-table-column label="账户名称" prop="accountname" align="center"/>
            <el-table-column label="累计充值（元）" prop="rechargeamount" align="center"/>
            <el-table-column label="总收益（元）" align="center">
              <template scope="scope">{{ fun(scope.row.totalamount - scope.row.rechargeamount) }}</template>
            </el-table-column>
            <el-table-column label="已消费（元）" prop="usedamount" align="center"/>
            <el-table-column label="账户余额（元）" prop="balance" align="center"/>
            <el-table-column label="提现金额（元）" prop="withdrawamount" align="center"/>
            <el-table-column label="操作" fixed="right" align="center">
              <template scope="scope">
                <span class="handle" @click="cardStatus(scope.row)">
                  <i :class="scope.row.status == 0?'el-icon-circle-close':'el-icon-circle-check'"/>
                  {{scope.row.status == 0?"禁用":"启用"}}
                </span>
                <span class="handle" @click="handleSee(scope.row)"> <i class="el-icon-view"/>查看</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination layout="prev, pager, next" @current-change="currentchangefive"
          :current-page="pageIndexfive" :page-size="10" :total="totalfive" style="float:right;margin:10px 0;"/>
        </div>
      </div>
    </div>
    <!-- 客源大厅 -->
    <div class="main_container" v-show="activeName=='first'">
      <div style="margin: 10px 0 10px 15px;">
        <b>有效收款：{{totalinfo.totalprice}}元</b><span style="color: #999;">（含6‰手续费）</span>
        <b>平台佣金：{{totalinfo.platformprice}}元　</b>
        <b>合伙人佣金：{{totalinfo.citypartnerprice}}元　</b>
        <b>创客佣金：{{totalinfo.userprice}}元</b>
      </div>
      <div class="table_container">
        <el-table :data="chargebackList" stripe border>
          <el-table-column prop="num" label="序号" width="60" align="center">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="交易流水号" align="center">
            <template scope="scope">{{scope.row.orderno}}</template>
          </el-table-column>
          <el-table-column label="交易时间" align="center">
            <template scope="scope">{{scope.row.paytime}}</template>
          </el-table-column>
          <el-table-column label="交易金额（元）" align="center">
            <template scope="scope">{{scope.row.price}}</template>
          </el-table-column>
          <el-table-column label="平台佣金（元）" align="center">
            <template scope="scope">{{scope.row.platformprice}}</template>
          </el-table-column>
          <el-table-column label="合伙人佣金（元）" align="center">
            <template scope="scope">{{scope.row.citypartnerprice}}</template>
          </el-table-column>
          <el-table-column label="创客佣金（元）" align="center">
            <template scope="scope">{{scope.row.userprice}}</template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="currentchangeOne"
        :page-size="10" :total="totalOne" :current-page="pageIndexOne" style="float:right;margin:10px 0"/>
      </div>
    </div>
    <!-- 用户钱包 -->
    <div class="main_container" v-show="activeName=='second'">
      <div style="margin: 20px;">
        用户钱包累计可提现金额：{{yhqb.balance}} 元
      </div>
    </div>
    <!-- 管理端 -->
    <div class="main_container" v-show="activeName=='third'">
      <div style="margin: 20px;">
        管理端累计可提现金额：{{gld.balance}} 元
      </div>
    </div>
    <!-- 运营充值记录 -->
    <div v-show="activeName=='fourth'">
      <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <div class="goodslist1">
            <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
            <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
          </div>
          <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
        </div>
        <el-collapse-transition>
        <div v-show="show3">
          <el-form class="findform">
            <el-form-item label="充值日期：" style="display:flex;">
              <el-date-picker type="daterange" v-model="orderTime" @change="changetime" style="width:90%;"
              value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
            </el-form-item>
            <el-form-item label="业务类型：" style="display:flex;width:30%" class="select">
              <el-select v-model="shztid" placeholder="请选择" style="width:90%;">
                <el-option v-for="(item,index) in shztArr" :key="index" :value="item.id" :label="item.name"/>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-right: 10px;"> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
            <el-form-item> <el-button type="primary" @click="handleyjz">新增记录</el-button> </el-form-item>
          </el-form>
        </div>
        </el-collapse-transition>
      </div>
      <div class="main_container">
        <section class="model_section">
          <el-col :span="18"> <p class="model_top_title">运营充值记录列表</p> </el-col>
        </section>
        <div class="table_container">
          <el-table :data="blacklist" stripe border>
            <el-table-column label="序号" width="60" align="center">
              <template scope="scope">{{scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column label="充值日期" align="center">
              <template scope="scope">{{scope.row.rechargetime}}</template>
            </el-table-column>
            <el-table-column label="充值业务" align="center">
              <template scope="scope">{{scope.row.rechargetypename}}</template>
            </el-table-column>
            <el-table-column label="充值金额（元）" align="center">
              <template scope="scope">{{scope.row.price}}</template>
            </el-table-column>
          </el-table>
          <el-pagination layout="prev, pager, next" @current-change="currentchangeTwo"
          :page-size="10" :total="totalTwo" :current-page="pageIndexTwo" style="float:right;margin:10px 0"/>
        </div>
      </div>
    </div>
  </div>
  <!-- 账单明细&充值记录&提现记录 -->
  <div v-else>
    <el-tabs v-model="zdmxczjltxjl" type="card" @tab-click="handleClickthree">
      <el-tab-pane label="账单明细" name="zdmxtab"/>
      <el-tab-pane label="充值记录" name="czjltab"/>
      <el-tab-pane label="提现记录" name="txjltab"/>
    </el-tabs>
    <div class="main_container">
      <section class="model_section">
        <el-col :span="18"> <p class="model_top_title">{{threetitle}}列表</p> </el-col>
      </section>
      <div class="table_container">
        <el-table :data="threelist" border style="width: 100%">
          <el-table-column prop="num" label="序号" width="60" align="center">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="交易流水号" prop="tradecode" align="center"/>
          <el-table-column label="交易时间" prop="paytime" align="center"/>
          <el-table-column label="交易类型" prop="tradetypename" align="center"/>
          <el-table-column label="交易对象" prop="trademodename" align="center"/>
          <el-table-column label="业务描述" align="center">
            <template scope="scope"><span class="spanList">{{ scope.row.remark }}</span></template>
          </el-table-column>
          <el-table-column label="金额（元）" align="center">
            <template scope="scope"><span v-show="scope.row.tradetype==2">-</span>{{scope.row.price}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="100">
            <template slot-scope="scope">
              <span class="handle" @click="seedrawer(scope.row)"> <i class="el-icon-view"/>查看</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="currentchangethree"
        :current-page="pageIndexthree" :page-size="10" :total="totalthree" style="float:right;margin:10px 0"/>
      </div>
      <div style="width: 100%;margin: 20px auto;text-align: center;display: flow-root;"><el-button @click="goback()">返回</el-button></div>
    </div>
  </div>
  <!-- 抽屉详情 size="50%" -->
  <el-drawer :visible.sync="detailsDialog">
    <template v-slot:title>
      <span style="font-size: 18px;font-weight: bolder;color: #333;">交易详情</span>
    </template>
    <div style="width: 90%; margin: 0 auto;border-bottom: 1px solid #eee;padding: 10px 0 20px 0;">
      <!-- <b>任务信息</b> -->
      <p><span>创建时间：</span> <span>{{formDetails.paytime}}</span></p>
      <p><span>交易对象：</span> <span>{{formDetails.trademodename}}</span></p>
      <p><span v-if="this.tradetype==1">交易方式：</span> <span v-else>支付方式：</span> <span>{{formDetails.paymodename}}</span></p>
      <p v-show="formDetails.isrefund==1"><span>退款方式：</span> <span>{{formDetails.paymodename}}</span></p>
      <p><span>交易金额：</span> <span><span v-show="formDetails.tradetype==2">-</span>{{formDetails.price}} 元</span></p>
      <p><span>交易状态：</span>
        <template v-if="formDetails.refundtradecode!=''">
          <span v-show="formDetails.isrefund==1">退款成功</span>
          <span v-show="formDetails.isrefund==0">全额退款</span>
        </template>
        <template v-else>
          <span>交易成功</span>
        </template>
      </p>
      <p><span>交易明细：</span> <span>{{formDetails.remark}}</span></p>
      <p><span>交易单号：</span> <span>{{formDetails.tradecode}}</span></p>
      <p v-show="formDetails.refundtradecode"><span>关联记录：</span>
        <span style="color: #409EFF; cursor: pointer;" @click="gljl(formDetails.refundtradecode)">{{formDetails.refundtradecode}}</span>
      </p>
    </div>
  </el-drawer>
  <!-- 新增记录-弹框 -->
  <el-dialog title="新增记录" :visible.sync="yjzsz" :center="true" width="20%">
    <el-form style="text-align: center;">
      <el-form-item label="充值日期：" label-width="70px" style="width:80%;">
        <el-date-picker type="date" v-model="czrqTime" placeholder="选择日期" value-format="yyyy-MM-dd" style="width:90%;"/>
      </el-form-item>
      <el-form-item label="充值业务：" label-width="70px" style="width:80%;">
        <el-select v-model="czywid" placeholder="选择业务" style="width:90%;">
          <el-option v-for="(item,index) in czywArr" :key="index" :value="item.id" :label="item.name"/>
        </el-select>
      </el-form-item>
      <el-form-item label="充值金额：" label-width="70px" style="width:80%;">
        <el-input v-model="yjzinput" placeholder="请输入" style="width:90%" maxlength="10"
        onkeyup="this.value=this.value.replace(/\D|^0/g,'')">
        <i slot="suffix" style="margin-right: 10px;">元</i>
        </el-input>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="text-align:center">
      <el-button type="danger" @click="yjzsz = false">取消</el-button>
      <el-button type="primary" @click="qdyjz()">确定</el-button>
    </div>
  </el-dialog>
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { getalllist, chnagestatus, vmaccountgetlist, vmaccountgetdetail, statisticsgetlist, userstatistics,
  partnerstatistics, rechargerecordgetlist, rechargerecordadd } from "../../api/shopWindow";
export default {
  name: "vmmanage",
  mixins: [alertTrends],
  data() {
    return {
      activeName: 'zjzh', // tab切换标识
      orderid: "", // 订单id
      shopid: '', // 店铺ID

      totalinfo: {}, // 客源大厅收益汇总信息
      chargebackList: [], // 客源大厅
      pageIndexOne: 1, // 页码
      totalOne: 0, // 总条数

      yhqb: {}, // 用户钱包
      gld: {}, // 管理端

      orderTime: "", // 申请时间
      beginTime: "", // 开始时间
      endTime: "", // 结束时间
      shztid: 0,
      shztArr: [
        {
          id: 0,
          name: "全部业务类型"
        },{
          id: 10,
          name: "客源大厅"
        },{
          id: 20,
          name: "用户钱包"
        },{
          id: 30,
          name: "管理端"
        },
      ],
      blacklist: [], // 运营充值记录
      pageIndexTwo: 1, // 页码
      totalTwo: 0, // 总条数
      
      yjzsz: false,
      czrqTime: '', // 充值日期
      czywid: '', // 充值业务
      czywArr: [{
        id: 10,
        name: "客源大厅"
      },{
        id: 20,
        name: "用户钱包"
      },{
        id: 30,
        name: "管理端"
      }],
      yjzinput: '', // 充值金额
      
      switchTab: true, // 一级二级切换
      show3: true,
      zhanghaoid: '', // 账号ID
      zhanghaoname: '', // 账户名称
      zjzhlist: [], // 资金账户列表
      pageIndexfive: 1, // 页码
      totalfive: 0, // 总条数
      
      zdmxczjltxjl: 'zdmxtab', // 账单明细&充值记录&提现记录
      threetitle: '账单明细',
      threelist: [],
      pageIndexthree: 1, // 页码
      totalthree: 0, // 总条数
      threetype: '',
      threeid: '',
      
      detailsDialog: false, // 抽屉详情
      tradetype: '',
      formDetails: {}, // 任务信息

    };
  },
  methods: {
    // 重置
    fnReset() {
      this.zhanghaoid = "";
      this.zhanghaoname = "";
    },
    // 计算总收益
    fun(val){
      return val.toFixed(2);
    },
    // 切换tab
    handleClickfive(tab){
      if(tab.name=='zjzh'){
        this.pageIndexfive = 1;
        this.getzjzh(); // 资金账户
      }
      if(tab.name=='first'){
        this.pageIndexOne = 1;
        this.getorder(); // 客源大厅
      }
      if(tab.name=='second'){
        let obj = {
          userid: localStorage.Id, // 用户ID 不传或传0则统计所有用户
        };
        userstatistics(obj).then(data => {
          if(data.resultCode == 1){
            this.yhqb = data.resultObj;
          }else{
            this.yhqb = 0;
          }
        })
      }
      if(tab.name=='third'){
        let obj = {
          userid: localStorage.Id, // 城市合伙人或BD的ID 不传或传0则统计所有用户
        };
        partnerstatistics(obj).then(data => {
          if(data.resultCode == 1){
            this.gld = data.resultObj;
          }else{
            this.gld = 0;
          }
        })
      }
      if(tab.name=='fourth'){
        this.pageIndexTwo = 1;
        this.gethmd(); // 运营充值记录
      }
    },
    // 查询
    onSubmit() {
      if(this.activeName=='zjzh'){
        this.pageIndexfive = 1;
        this.getzjzh(); // 资金账户
      }else if(this.activeName=='first'){
        this.pageIndexOne = 1;
        this.getorder(); // 客源大厅
      }else{
        this.pageIndexTwo = 1;
        this.gethmd(); // 运营充值记录
      }
    },
    // 获取客源大厅列表
    getorder() {
      let obj = {
        pageindex: this.pageIndexOne,
        pagesize: 10
      };
      statisticsgetlist(obj).then(data => {
        if(data.resultCode == 1){
          this.chargebackList = data.resultObj.list;
          this.totalinfo = data.resultObj.totalinfo;
          this.totalOne = data.resultObj.totalcount;
        }else{
          this.chargebackList = [];
          this.totalOne = 0;
        }
      })
    },
    // 分页
    currentchangeOne(val) {
      this.pageIndexOne = val;
      this.getorder();
    },
    // 获取运营充值记录列表
    gethmd() {
      let obj = {
        bdate: this.beginTime, // 充值日期-起始 格式：yyyy-MM-dd
        edate: this.endTime, // 充值日期-截止 格式：yyyy-MM-dd
        rechargetype: this.shztid, // 充值类型：10=客源大厅 20=用户钱包 30=管理端
        pageindex: this.pageIndexTwo,
        pagesize: 10
      };
      rechargerecordgetlist(obj).then(data => {
        if(data.resultCode == 1){
          this.blacklist = data.resultObj.list;
          this.totalTwo = data.resultObj.totalcount;
        }else{
          this.blacklist = [];
          this.totalTwo = 0;
        }
      })
    },
    // 分页
    currentchangeTwo(val) {
      this.pageIndexTwo = val;
      this.gethmd();
    },
    // 新增记录
    handleyjz(){
      this.czrqTime = '';
      this.czywid = '';
      this.yjzinput = '';
      this.yjzsz = true;
    },
    // 确定
    qdyjz(){
      let obj = {
        operatorid: localStorage.Id, // 操作人id
        date: this.czrqTime, // 充值日期 格式：yyyy-MM-dd
        type: this.czywid, // 充值类型：10=客源大厅 20=用户钱包 30=管理端
        price: this.yjzinput, // 充值金额 单位：元
      };
      rechargerecordadd(obj).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.yjzsz = false;
          this.gethmd(); // 运营充值记录
        }
      });
    },
    // 申请时间
    changetime() {
      if(this.orderTime + "" == "null"){
        this.orderTime = ["",""]
      }
      this.beginTime = this.orderTime[0];
      this.endTime = this.orderTime[1];
    },
    // 获取资金账户列表
    getzjzh() {
      let obj = {
        vmid: this.zhanghaoid, // 账号ID
        name: this.zhanghaoname, // 账户名称
        pageindex: this.pageIndexfive,
        pagesize: 10
      };
      getalllist(obj).then(data => {
        if(data.resultCode == 1){
          this.zjzhlist = data.resultObj.list;
          this.totalfive = data.resultObj.totalcount;
        }else{
          this.zjzhlist = [];
          this.totalfive = 0;
        }
      })
    },
    // 资金账户-分页
    currentchangefive(val){
      this.pageIndexfive = val;
      this.getzjzh();
    },
    // 启用&禁用
    cardStatus(row){
      this.$swal({
        type: "warning",
        text: row.status == 0 ? "是否执行禁用操作" : "是否执行启用操作",
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        if (res.value) {
          // 确定执行操作
          let obj = {
            vmid: row.vmid, // 账户ID
            status: row.status == 0 ? 1 : 0 // 账户状态 0=启用 1=停用
          }
          chnagestatus(obj, row.businesstype, row.businessid).then(data=>{
            if(data.resultCode == 1){
              this.getzjzh();
              this.showAlert('操作成功', 'success');
            }
          })
        }
      });
    },
    // 查看详情
    handleSee(row){
      this.threetype = row.businesstype; // 业务主体类型 3=商家 4=个人
      this.threeid = row.businessid; // 业务主体类型3=商家 4=个人
      this.switchTab=false;
      this.zdmxczjltxjl='zdmxtab';
      this.pageIndexthree = 1;
      this.getthree(); // 详情tab
    },
    // 账单明细&充值记录&提现记录 - 切换tab
    handleClickthree(tab){
      this.pageIndexthree = 1;
      this.getthree();
      if(tab.name=='zdmxtab'){
        this.threetitle='账单明细';
      }else if(tab.name=='czjltab'){
        this.threetitle='充值记录';
      }else{
        this.threetitle='提现记录';
      }
    },
    // 账单明细&充值记录&提现记录 - 列表
    getthree() {
      let result = this.zdmxczjltxjl=='zdmxtab' ? 0 : this.zdmxczjltxjl=='czjltab' ? 1 : 2;
      let obj = {
        mode: result, // tabid
        pageindex: this.pageIndexthree,
        pagesize: 10
      };
      vmaccountgetlist(obj,this.threetype,this.threeid).then(data => {
        if(data.resultCode == 1){
          this.threelist = data.resultObj.list;
          this.totalthree = data.resultObj.totalcount;
        }else{
          this.threelist = [];
          this.totalthree = 0;
        }
      })
    },
    // 账单明细&充值记录&提现记录 - 分页
    currentchangethree(val){
      this.pageIndexthree = val;
      this.getthree();
    },
    // 查看抽屉
    seedrawer(row){
      this.tradetype=row.tradetype; // 交易类型
      this.detailsDialog=true;
      vmaccountgetdetail('', this.threetype, this.threeid, row.tradecode).then(data => {
        this.formDetails = data.resultObj; // 交易详情
      });
    },
    // 关联记录
    gljl(row){
      this.detailsDialog=true;
      vmaccountgetdetail('', this.threetype, this.threeid, row).then(data => {
        this.formDetails = data.resultObj; // 交易详情
      });
    },
    // 返回
    goback(){
      this.switchTab=true;
      // this.pageIndexfive = 1;
      // this.getzjzh(); // 刷新第一个tab 资金账户列表
    },

  },
  mounted() {
    this.getzjzh(); // 刷新第一个tab 资金账户列表
  }
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// vmmanage.vue?1923bdea